"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixTextUnderscores = void 0;
const tex_syntax_1 = require("./tex-syntax");
const textWithBlockArg = new RegExp(`\\\\(text|textbf)(${(0, tex_syntax_1.block)(3)})`, "g");
function fixUnderscoresInsideInnerBlock(tex) {
    return (tex
        // Fix specific cases
        .replace(new RegExp("_Multipliziere "), "Multipliziere ")
        // words with _'s, eg: tiger_friend
        .replace(/\$[^$]*\$|\\_|_/g, (token) => {
        if (token === "_") {
            return "\\_";
        }
        return token;
    }));
}
function fixTextUnderscores(tex) {
    return tex.replace(/^\s*(_+)\s*$/, "\\text{$1}").replace(
    // Find all occurrences of \text or \textbf followed by a block...
    textWithBlockArg, 
    // ...and fix up the contents of the block...
    (wholeString, command, innerBlock) => {
        return `\\${command}${fixUnderscoresInsideInnerBlock(innerBlock)}`;
    });
}
exports.fixTextUnderscores = fixTextUnderscores;
